(() => {
  const TOGGLE_ID = 'vp_protection_checkout_toggle';
  const SUB_VARIANT_ID = 53519622570313;      // warranty product variant
  const SUB_SELLING_PLAN_ID = 690718638409;   // monthly selling plan

  let queue = Promise.resolve(); // runs cart actions one by one, in order
  let pending = 0;
  let lastToggleEl = null;
  let syncTimer = null;

  const getToggle = () => document.getElementById(TOGGLE_ID);
  const hasSub = (cart) => (cart.items || []).some(i => i.variant_id === SUB_VARIANT_ID);

  async function fetchCart() {
    const r = await fetch('/cart.js', {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    });
    if (!r.ok) throw new Error('Could not load cart (' + r.status + ')');
    return r.json();
  }

  async function postJSON(url, body) {
    const r = await fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
    const data = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(data.description || data.message || 'Cart update failed');
    return data;
  }

  async function addSub() {
    const cart = await fetchCart();
    if (hasSub(cart)) return cart;
    await postJSON('/cart/add.js', {
      items: [{ id: SUB_VARIANT_ID, quantity: 1, selling_plan: SUB_SELLING_PLAN_ID }]
    });
    return fetchCart();
  }

  async function removeSub() {
    const cart = await fetchCart();
    const updates = {};
    (cart.items || []).forEach(i => {
      if (i.variant_id === SUB_VARIANT_ID) updates[i.key] = 0;
    });
    if (!Object.keys(updates).length) return cart;
    await postJSON('/cart/update.js', { updates });
    return fetchCart();
  }

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency || 'USD'
      }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function showError(msg) {
    const row = document.getElementById('vp_protection_row');
    if (!row) return;
    let el = document.getElementById('vp_protection_error');
    if (!el) {
      el = document.createElement('div');
      el.id = 'vp_protection_error';
      el.style.cssText = 'color:#dd1d1d;font-size:13px;margin-top:6px;';
      row.insertAdjacentElement('afterend', el);
    }
    el.textContent = msg || '';
    el.style.display = msg ? 'block' : 'none';
  }

  // Updates the toggle + Subtotal from the real cart (only if something changed)
  function render(cart) {
    if (!cart) return;

    const toggle = getToggle();
    if (toggle) toggle.checked = hasSub(cart);

    const text = money(cart.total_price, cart.currency);
    document.querySelectorAll('.cart-drawer__totals__row').forEach(row => {
      const label = (row.querySelector('span')?.innerText || '').trim().toLowerCase();
      if (label !== 'subtotal') return;
      const el = row.querySelector('.cart-drawer__totals__row__money');
      if (el && el.textContent.trim() !== text) el.textContent = text;
    });
  }

  function syncFromCart() {
    if (pending) return;
    fetchCart().then(render).catch(() => {});
  }

  // 1) User clicks the toggle
  document.addEventListener('change', (e) => {
    const t = e.target;
    if (!t || t.id !== TOGGLE_ID) return;

    const wantOn = t.checked;
    t.disabled = true;
    showError('');
    pending++;

    queue = queue
      .then(() => (wantOn ? addSub() : removeSub()))
      .then(render)
      .catch(async (err) => {
        console.error('[VP Protection]', err);
        showError(err.message);
        try { render(await fetchCart()); } catch (e2) {}
      })
      .finally(() => {
        pending--;
        const tt = getToggle();
        if (tt) tt.disabled = false;
      });
  }, true);

  // 2) On page load: read the cart, never remove anything
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncFromCart);
  } else {
    syncFromCart();
  }

  // 3) When the theme re-draws the cart drawer, re-sync once (no loop)
  new MutationObserver(() => {
    const t = getToggle();
    if (t && t !== lastToggleEl) {
      lastToggleEl = t;
      clearTimeout(syncTimer);
      syncTimer = setTimeout(syncFromCart, 150);
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  // 4) If Checkout is clicked while the warranty is still saving, wait for it first
  function isCheckoutIntent(el) {
    const n = el?.closest?.('a, button, input[type="submit"], form');
    if (!n) return false;
    if (n.tagName === 'A' && (n.getAttribute('href') || '').toLowerCase().includes('/checkout')) return true;
    if (n.tagName === 'FORM' && (n.getAttribute('action') || '').toLowerCase().includes('/checkout')) return true;
    if ((n.getAttribute('name') || '').toLowerCase() === 'checkout') return true;
    const text = ((n.innerText || n.value || '') + '').toLowerCase();
    if (text.includes('checkout') || text.includes('check out')) return true;
    return !!el.closest?.('form[action*="/checkout"]');
  }

  function replayOriginalAction(target) {
    const form = target.closest?.('form[action*="/checkout"]');
    if (form) { form.requestSubmit ? form.requestSubmit() : form.submit(); return; }
    const link = target.closest?.('a[href]');
    if (link) { window.location.href = link.href; return; }
    const btn = target.closest?.('button, input[type="submit"], input[name="checkout"]');
    if (btn) btn.click();
  }

  document.addEventListener('click', (e) => {
    if (!pending) return;                 // nothing saving → normal checkout
    if (!isCheckoutIntent(e.target)) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    const target = e.target;
    queue.then(() => replayOriginalAction(target));
  }, true);
})();